import { FC } from "react";
import {
  FacebookPixelScript,
  FacebookPixelRouteTracker,
  GoogleTagManagerScript,
} from "~features/tracking/marketing/integrations";
import { useCookieConsent } from "~context/cookieConsentContext";
import { OptionalSeekaProvider, orgLevelSeeka } from "~lib/seeka";
import { useOrganization } from "~hooks";
import { useRouter } from "next/router";

export const MarketingConsentProvider: FC = ({ children }) => {
  const { isMarketingAllowed } = useCookieConsent();
  const { organization } = useOrganization();
  const router = useRouter();

  if (isMarketingAllowed) {
    return (
      <>
        <FacebookPixelScript pixelId={organization?.marketing?.pixelId} />
        <FacebookPixelRouteTracker pixelId={organization?.marketing?.pixelId} />
        <GoogleTagManagerScript containerId={organization?.marketing?.gtmId} />
        <OptionalSeekaProvider
          seekaConfig={organization?.seekaConfig}
          enabled={orgLevelSeeka(router?.pathname)}
        >
          {children}
        </OptionalSeekaProvider>
      </>
    );
  }

  return <>{children}</>;
};
